module.exports = "<p>\n  entry-page works!\n</p>\n"